import { CdkVirtualScrollViewport, VIRTUAL_SCROLL_STRATEGY } from '@angular/cdk/scrolling';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { GroupService } from '@api/services/group.service';
import { HeaderService } from '@api/services/header.service';
import { UserApiService } from '@api/services/user.service';
import { CustomVirtualScroll } from '@classes/CustomVritualScoll';
import { FireBase } from '@classes/fireBase';
import { MovimientoDetails } from '@models/MovimientoDetails.model';
import { Mygroup } from '@models/group.model';
import { MPerson } from '@models/person.model';
import { TipoMovimiento } from '@models/tipos-movimiento.model';
import { BottomSheetMovimientos } from '@shared/components/bottomSheet/bottomSheetMovimiento/bottomSheetMovimiento.component';
import { logEvent } from 'firebase/analytics';
import { filter, map, pairwise, throttleTime } from 'rxjs';


@Component({
    selector: 'app-single-movement',
    templateUrl: './single-movement.component.html',
    styleUrls: [
        './single-movement.component.scss',
    ],
    providers: [{ provide: VIRTUAL_SCROLL_STRATEGY, useClass: CustomVirtualScroll },],
    standalone: false
})
export class SingleMovementComponent extends FireBase implements OnInit, OnChanges, AfterViewInit {

	@Input() movimientos: any[] = [];
	@Input() cliente?: any = null;
	@Input() grupo?: Mygroup = null;
	@Input() isLoading: Boolean = false;
	@Input() isLastPageMv: boolean = false;
	@Input() mvPage: number = 1;
	@Input() errorLoadPage = false;	
	
	@Output() onNext = new EventEmitter<string | undefined>();
	@Output() onPrev = new EventEmitter<string | undefined>();
	@Output() onCategory = new EventEmitter<string | undefined>();
	@Output() mvPageChange = new EventEmitter<number>();

	public modeGroup: boolean = false;	

	public actividad: any[] = [];
	public selectedCategory: string | null = null;	

	@ViewChild('scrollContent', { static: false }) scrollContent!: ElementRef;	
	@ViewChild('scroll') scroller: CdkVirtualScrollViewport;

	isDown = false;
	startX = 0;
	scrollLeft = 0;

	public saldo: any;
	public saldoMiembro: any;

	public person: MPerson = null;

	public imagen;
	public cliente_id;
	public nombreUser;
	public firstLetterName;
	public miembro_id = null;
	public miembro = null;

	constructor(private router: Router, 
				private bottomShet: MatBottomSheet, 
				private headerService: HeaderService,
				private groupService: GroupService,
				private userService: UserApiService,
				private routeActive: ActivatedRoute,
				private ngZone: NgZone) {
		super();
	}

	ngOnInit(): void {
		this.headerService.modeGrupoCoolOb.subscribe(res => { 
			this.modeGroup = res;
			if (this.modeGroup) {
				if (this.grupo == null) {
					this.groupService.getGroup.subscribe(res => {
						this.grupo = res;
					});
				}
				if (this.router.url.includes('saldo-persona')) {
					this.routeActive.url.subscribe(urlSegments => {
						this.miembro_id = urlSegments[urlSegments.length - 1]?.path || '';
					});
					this.miembro = this.grupo.miembros.filter((x:any) => x.cliente_id == this.miembro_id ? x : '')[0];
					this.saldo = Number(this.miembro.saldo.saldo_tarjeta) + Number(this.miembro.saldo.saldo_premios) + Number(this.miembro.saldo.saldo_no_disponible);
				}
				else {
					this.userService.usuarioObservable.subscribe(res => {
						this.person = res;
						this.cliente_id = res.client.id;
						this.nombreUser = res.name + " " + res.surname;
						this.firstLetterName = res.name[0].toUpperCase();

						let member = this.grupo.miembros.filter((x:any) => x.cliente_id == this.cliente_id ? x : '')[0];
						this.saldoMiembro = Number(member.saldo.saldo_tarjeta) + Number(member.saldo.saldo_premios) + Number(member.saldo.saldo_no_disponible);
					});
					this.saldo = Number(this.grupo.saldo.saldo_tarjeta)+Number(this.grupo.saldo.saldo_premios) + Number(this.grupo.saldo.saldo_no_disponible);
				}
			}
			else {
				logEvent(this.analytics, 'MY_FUNDS');
				if (this.cliente == null) {
					this.userService.usuarioObservable.subscribe(res => {
						if(res) {
							this.cliente = res.client;
							this.saldo = this.cliente.getSaldoTotal();
						}
					});
				}
				else {
					this.saldo = this.cliente.getSaldoTotal();
				}
			}
		});
	}

	@HostListener('mousedown', ['$event'])
	onMouseDown(event: MouseEvent): void {
		this.isDown = true;
		const target = this.scrollContent.nativeElement as HTMLElement;
		this.startX = event.pageX - target.offsetLeft;
		this.scrollLeft = target.scrollLeft;
		target.style.cursor = 'grabbing';
	}

	@HostListener('mouseleave')
	onMouseLeave(): void {
		this.isDown = false;
		const target = this.scrollContent.nativeElement as HTMLElement;
		target.style.cursor = 'grab';
	}

	@HostListener('mouseup')
	onMouseUp(): void {
		this.isDown = false;
		const target = this.scrollContent.nativeElement as HTMLElement;
		target.style.cursor = 'grab';
	}

	@HostListener('mousemove', ['$event'])
	onMouseMove(event: MouseEvent): void {
		if (!this.isDown) return;
		event.preventDefault();
		const target = this.scrollContent.nativeElement as HTMLElement;
		const x = event.pageX - target.offsetLeft;
		const walk = (x - this.startX) * 2;
		target.scrollLeft = this.scrollLeft - walk;
	}

	ngOnChanges(): void {
		this.filterActividad();		
	}

	getTitle(movimiento: any) {
		var title = "";
		switch (this.getCategoryById(movimiento.tipo_movimiento)) {
			case 'INGRESO':
				title = 'Ingreso';
				break;
			case 'COBRO':
				title = 'Transferencia a cuenta bancaria';
				break;
			case 'PAGO':
				if (movimiento?.tipo_movimiento == 4)
					title = 'Suscripcion - Pedido ' + movimiento?.datos?.pedido?.id;
				else {
					if (movimiento?.datos?.pedido?.id)
						title = 'Jugada - Pedido ' + movimiento?.datos?.pedido?.id;
					else
						title = 'Pago';
					break;
				}
				break;
			case 'PREMIO':
				title = 'Premio';
				break;
			case 'PROMOCION':
				title = 'Promoción';
				break;
			case 'INFORMACION':
				title = 'Conversión';
				break;
			default:
				title = (!this.comprobarCobro(movimiento.importe) ? (movimiento.tipo_movimiento == 2 ? 'Premio' : 'Ingreso') : 'Cobro');
				break;			
		}

		return title;
	}

	comprobarCobro(saldo: any) {
		if (saldo >= 0)
			return false;
		return true;
	}

	ingresarBtn() {
		if (this.modeGroup) {
			this.router.navigate(['/','cliente','mis-grupos','detalles',this.grupo.cliente_id,this.grupo.nombre,'ingresar']);
		}
		else {
			this.router.navigate(['/', 'cliente', 'ingresar']);
		}
	}

	retirarBtn() {
		if (this.modeGroup) {
			this.router.navigate(['/','cliente','mis-grupos','detalles',this.grupo.cliente_id,this.grupo.nombre,'cobrar']);
		}
		else {
			this.router.navigate(['/', 'cliente', 'cobrar']);
		}
	}

	verSaldo()
    {
        this.headerService.set_rutaBack(this.router.url)
        this.router.navigate(['/','cliente','mis-grupos','detalles',this.grupo.cliente_id,this.grupo.nombre,'saldo-persona',this.cliente_id]);
    }

	openSheet(movimiento: any) {
		let movimientoDetails = new MovimientoDetails()
		movimientoDetails.concepto = movimiento.concepto_api
		movimientoDetails.importe = movimiento.importe

		movimientoDetails.fecha = movimiento.fecha

		movimientoDetails.tipo_movimiento = movimiento.importe > 0 ? 'Ingreso Realizado' : 'Cobro efectuado';

		switch (movimiento.tipo_movimiento) {
			case 2:
				movimientoDetails.tipo_movimiento = 'Premio recibido';
				break;
			case 6:
				movimientoDetails.tipo_movimiento = 'Premio recibido';
				break;
			case 52:
				movimientoDetails.tipo_movimiento = 'Conversión';
				break;
			case 74:
				movimientoDetails.tipo_movimiento = 'Conversión';
				break;
			case 16:
				movimientoDetails.tipo_movimiento = 'Transferencia efectuada';
				break;
			default:
				//this.title.push(!this.comprobarCobro(movimiento.importe) ? (movimiento.tipo_movimiento == 2 ? 'Premio' : 'Ingreso') : 'Cobro');
				break;
		}

		this.bottomShet.open(BottomSheetMovimientos, { data: { movimiento: movimientoDetails } })
	}

	ngAfterViewInit(): void {
		this.onScroll();
	}
		
	
	public onScroll() {
		this.scroller.elementScrolled().pipe(
			throttleTime(1)
		).subscribe(() => {
			this.ngZone.run(() => {			
				const scrollBottom = this.scroller.measureScrollOffset('bottom');
				const scrollTop = this.scroller.measureScrollOffset('top');

				if (!this.isLastPageMv && !this.isLoading && scrollBottom <= 1 && !this.errorLoadPage) {
					this.mvPage++;
					this.mvPageChange.emit(this.mvPage);

					if (this.mvPage > 1)
						this.isLoading = true;

					this.onNext.emit(this.selectedCategory !== null ? this.selectedCategory.toLowerCase() : undefined);				
				}				

				if (this.mvPage > 1 && !this.isLoading && scrollTop <= 150 && !this.errorLoadPage) {

					// Guardamos el primer elemento visible antes de cargar									
					const offsetBefore = this.scroller.measureScrollOffset('top');

					this.mvPage--;  // vamos hacia atrás
					this.mvPageChange.emit(this.mvPage);
					
					if (this.mvPage > 1)
						this.isLoading = true;

					this.onPrev.emit(this.selectedCategory !== null ? this.selectedCategory.toLowerCase() : undefined);									

					setTimeout(() => {				
						let newOffset = offsetBefore + (25 * 5);						
						this.scroller.scrollToOffset(newOffset);
						this.isLoading = false;
					}, 0);				
				}
			})
		})		
	}

	retry(isDown: boolean = false) {
		if(isDown) {
			this.onNext.emit(this.selectedCategory);
		} else {
			this.onPrev.emit(this.selectedCategory);
		}
	}

	onCategoryClick(category: string | null): void {
		this.selectedCategory = category;
		this.mvPage = 1;
		this.isLastPageMv = false;
		this.movimientos = [];
		this.mvPageChange.emit(this.mvPage);
		this.onCategory.emit(this.selectedCategory !== null ? this.selectedCategory.toLowerCase() : undefined);
	}

	private filterActividad(): void {
		if (this.selectedCategory == null) {
		  	this.actividad = this.movimientos;
		  	return;
		}
	
		// const ids = Object.values(TipoMovimiento.tipos[this.selectedCategory] || {});
		// this.actividad = this.movimientos.filter(movimiento =>
		//   	ids.includes(movimiento.tipo_movimiento)
		// );
	}

	getCategoryById(id) {
		for (let category in TipoMovimiento.tipos) {
			for (let key in TipoMovimiento.tipos[category]) {
				if (TipoMovimiento.tipos[category][key] === id) {					
					return category;
				}
			}
		}
		return null;
	}
}
